import React from "react";
import PropTypes from "prop-types";

import { createPOFields } from "./createPOFields";
import { LabeledTextContext } from "../../../../withPORevision";
import Header from "./Header";
import { Paper } from "../../../mui/core";
import { FormGrid } from "../../../forms";

const Section = formGridProps => {
  const { discount, purchaseOrder } = formGridProps.initialValues;
  const { timezone } = formGridProps;
  const currency = purchaseOrder?.projectCurrency?.currency;
  return (
    <LabeledTextContext.Provider value={true}>
      <Paper>
        <Header purchaseOrder={purchaseOrder} />
        <FormGrid fields={createPOFields(discount, currency, timezone)} />
      </Paper>
    </LabeledTextContext.Provider>
  );
};

Section.propTypes = {
  timezone: PropTypes.string,
};

export default Section;
